import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import StarBorderOutlinedIcon from "@material-ui/icons/StarBorderOutlined";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { db } from "../../services/firebase";
import { selectRoomId } from "../../store/appSlice";
import ChatInput from "../ChatInput/ChatInput";
import Message from "../Message/Message";
import {
  ChatBottom,
  ChatContainer,
  ChatMessages,
  EmptyChannel,
  Header,
  HeaderLeft,
  HeaderRight,
} from "./Chat.elements";

function Chat() {
  const chatRef = useRef(null);
  let roomId = useSelector(selectRoomId);
  const [messages, setMessages] = useState([]);
  const [roomName, setRoomName] = useState("");
  const { id } = useParams();

  if (!roomId) {
    roomId = id;
  }

  const roomDetails = useMemo(() => doc(db, "rooms", roomId), [roomId]);
  const roomMessages = useMemo(
    () => collection(roomDetails, "messages"),
    [roomDetails]
  );
  const q = useMemo(
    () => query(roomMessages, orderBy("timestamp", "asc")),
    [roomMessages]
  );

  getDoc(roomDetails)
    .then((snapshot) => {
      setRoomName(snapshot.data().name);
    })
    .catch(() => alert("Error while getting room name."));

  useEffect(() => {
    roomId &&
      onSnapshot(q, (snapshot) => {
        const messageDocs = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setMessages(messageDocs);
      });
  }, [roomId, q]);

  useEffect(() => {
    chatRef?.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [roomId]);

  return (
    <ChatContainer>
      {roomId && roomDetails && roomMessages && (
        <React.Fragment>
          <Header>
            <HeaderLeft>
              <h4>
                <strong>#{roomName}</strong>
              </h4>
              <StarBorderOutlinedIcon />
            </HeaderLeft>

            <HeaderRight>
              <p>
                <InfoOutlinedIcon /> Details
              </p>
            </HeaderRight>
          </Header>
          <ChatMessages>
            {messages.length === 0 && (
              <EmptyChannel>
                <h1>No messages here...yet :)</h1>
              </EmptyChannel>
            )}
            {messages?.map((doc) => {
              return <Message message={doc} key={doc.id} />;
            })}
          </ChatMessages>
          <ChatBottom ref={chatRef} />

          <ChatInput
            chatRef={chatRef}
            channelName={roomName}
            channelId={roomId}
          />
        </React.Fragment>
      )}
    </ChatContainer>
  );
}

export default Chat;
